/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-restricted-imports  */
import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetBrNavigationsResponse, SubMenu } from './appstate.models';
import { catchError, map, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AppstateService } from './appstate.service';
import { AppstateFacade } from './appstate.facade';
import { appStateQuery } from './appstate.selectors';
import { AppStatePartialState } from './appstate.reducer';
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { TranslateService } from '@ngx-translate/core';
import {
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
import { get } from 'lodash';

@Injectable()
export class AuthenticationGuard {
  hasIFP: boolean;
  hasCSB: boolean;
  hasMA: boolean;
  hasSGP: boolean;
  hasUSE: boolean;
  isMaCsbOnly: boolean;
  envName: string;
  isCheckMaCsbLobEnabledFlag: any;
  constructor(
    private router: Router,
    private appstateService: AppstateService,
    private appstateFacade: AppstateFacade,
    private _store$: Store<AppStatePartialState>,
    public loginFacade: LoginFacade,
    public translate: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this._store$
      .select(appStateQuery.getCachedBrokerNavigationResponse)
      .pipe(
        take(1),
        switchMap((cachedResponse) =>
          cachedResponse
            ? of({
                navigationResponse: cachedResponse,
                fromStore: true,
              })
            : this.appstateService.getBrokerNavigations().pipe(
                map((navigationResponse: GetBrNavigationsResponse) => ({
                  navigationResponse,
                  fromStore: false,
                })),
              ),
        ),
        map(({ navigationResponse, fromStore }) => {
          const entitlementMenu: string = route.data['entitlementMenu'];
          const entitlementMenuArray: string[] = entitlementMenu.split(',');

          let isValidRoute = false;

          if (entitlementMenu === 'login-success-dialog') {
            // Logout and navigate to redirect page

            if (navigationResponse?.data) {
              // Check for roles
              if (navigationResponse?.data?.roles) {
                navigationResponse?.data?.roles.forEach((roleitem) => {
                  if (roleitem.lob === 'IFP') {
                    this.hasIFP = true;
                  } else if (roleitem.lob === 'CSB') {
                    this.hasCSB = true;
                  } else if (roleitem.lob === 'MA') {
                    this.hasMA = true;
                  } else if (roleitem.lob === 'SGP') {
                    this.hasSGP = true;
                  } else if (roleitem.lob === 'COMMERCIAL') {
                    this.hasUSE = true;
                  }
                });
              }

              if (
                !this.hasUSE &&
                !this.hasSGP &&
                !this.hasIFP &&
                (this.hasMA || this.hasCSB)
              ) {
                this.isMaCsbOnly = true;
              }

              // get flag from resource bundle
              this.envName = this._config.environmentName;
              const featureFlagBase = this.translate.instant(`featureFlag`);

              const flagObj = get(featureFlagBase, this.envName);
              this.isCheckMaCsbLobEnabledFlag = get(
                flagObj,
                'isCheckMaCsbLobEnabled',
              );

              // check for pilot user
              if (
                (!this.isCheckMaCsbLobEnabledFlag &&
                  navigationResponse.data?.isNpnPilot) ||
                (this.isCheckMaCsbLobEnabledFlag && this.isMaCsbOnly)
              ) {
                localStorage.setItem('redirectfromcfb', 'true');
                this.loginFacade.logout('logout');
              } else {
                return true;
              }
            }
          } else {
            if (!fromStore && navigationResponse?.data) {
              this.appstateFacade.setBrNavigationSuccess(navigationResponse);
            }

            navigationResponse.data?.navigation?.menus.forEach((menu) => {
              // Loop through menu
              if (
                entitlementMenuArray.some(
                  (entitlement) => entitlement === menu.entitlement,
                )
              ) {
                isValidRoute = true;
              }

              // Loop through l2 menu
              if (
                menu.subMenus?.some((subMenu: SubMenu) =>
                  entitlementMenuArray.some(
                    (entitlement) => entitlement === subMenu.entitlement,
                  ),
                )
              ) {
                isValidRoute = true;
              }

              // Loop through l3 submenu items for Tools section
              menu.subMenus?.forEach((l3menu: SubMenu) => {
                if (
                  l3menu.l3Menus?.some((l3SubMenu: SubMenu) =>
                    entitlementMenuArray.some(
                      (entitlement) => entitlement === l3SubMenu.entitlement,
                    ),
                  )
                ) {
                  isValidRoute = true;
                }
              });
            });

            // Check other entitlements
            navigationResponse.data?.navigation?.entitlements.forEach(
              (menu) => {
                if (
                  entitlementMenuArray.some(
                    (entitlement) => entitlement === menu,
                  )
                ) {
                  isValidRoute = true;
                }
              },
            );

            if (isValidRoute) {
              return true;
            }
            this.router.navigate(['secure/not-authorized'], {
              replaceUrl: true,
            });
          }
          return false;
        }),
        catchError((_error) => {
          this.appstateFacade.sendAnalytics({
            event: 'error',
            reqData: {
              requirementId: 'acCFBGlobER001',
              userStory: 'MTD-3109',
              hitType: 'error',
            },
            errorData: {
              errorType: 'Navigation_API',
              errorCause:
                'Our application is currently unavailable. Please try again later.',
              errorCode: 'E99999',
            },
            v2: 'CFB - Home Dashboard',
          });

          this.router.navigate(['secure/not-authorized'], {
            replaceUrl: true,
          });
          return [false];
        }),
      );
  }
}
